import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Box } from '@chakra-ui/react';

import Heading from 'components/_core/Heading';
import SunshineCard from 'components/_core/SunshineCard';
import Text from 'components/_core/Text';
import * as routes from 'features/Referral/routes';
import { referrerRewardAmount } from 'features/Referral/utils';

import { Referral } from '../../../../features/Referral/hooks/useReferral';
import locales from './locales';

interface ReferralOverviewProps {
  referrals: Referral[];
}

const validatedReferral = (referrals: Referral[]) => {
  return referrals.filter((referral) => {
    return (
      referral.displayedStatus === 'REFERRER_REWARDED' ||
      referral.displayedStatus === 'MAX_REFERRER_REWARDS_REACHED'
    );
  });
};

const getTotalReward = (referrals: Referral[]): number => {
  let total = 0;

  referrals.forEach((referral) => {
    if (
      referral.displayedStatus === 'REFERRER_REWARDED' &&
      referral.referrerRewardAppliedAt
    ) {
      total += referrerRewardAmount(new Date(referral.referrerRewardAppliedAt));
    }
  });
  return total;
};

const ReferralOverview: FC<ReferralOverviewProps> = ({ referrals }) => {
  return (
    <Box as={Link} display="flex" flexDirection="row" gap={8} to={routes.list}>
      <SunshineCard marginBottom="space-24">
        <SunshineCard.Content alignItems="start" direction="column" gap={16}>
          <Text variant="primary">{locales.validatedReferral}</Text>
          <Heading size="xl" variant="number">
            {validatedReferral(referrals).length}
          </Heading>
        </SunshineCard.Content>
      </SunshineCard>
      <SunshineCard marginBottom="space-24">
        <SunshineCard.Content alignItems="start" direction="column" gap={16}>
          <Text variant="primary">{locales.totalReward}</Text>
          <Heading size="xl" variant="number">
            {locales.formatString(locales.totalAMount, {
              amount: getTotalReward(referrals),
            })}
          </Heading>
        </SunshineCard.Content>
      </SunshineCard>
    </Box>
  );
};

export default ReferralOverview;
